module.exports = __webpack_public_path__ + "img/universebg.275aeb3c.jpg";